import { AxiosCountyData } from './AxiosCountyData'
import { CountyFactory, County, CountyFactoryError, CountyCode, CountyName } from '@/Domain/Localization/County'

export class AxiosCountyFactory implements CountyFactory<AxiosCountyData> {
  makeCounty (data: AxiosCountyData): County {
    try {
      return new County(new CountyCode(data.code), new CountyName(data.name))
    } catch (error) {
      throw new CountyFactoryError(error.message)
    }
  }
}
